import { projectClient } from './projectClient';

/** The logged-in user again + a download of a missing project list (and the permissions). */
export function refreshUserAndProjectsList(refreshCurrentUser: () => Promise<void>): void {
  void refreshCurrentUser();
  projectClient.downloadWhenMissing();
}

/** The logged-in user again + a new download of the project list (GET /v2/project). Use on select-project screen. */
export function syncUserAndProjectsList(refreshCurrentUser: () => Promise<void>): void {
  void refreshCurrentUser();
  projectClient.sync();
}
